import { useSearchParams } from "react-router-dom";

// The record under test lives in `?id=` so a reload or a shared link reopens it.
const useRecordIdParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawId = searchParams.get("id");
  const id = rawId ? Number(rawId) : null;

  const setId = nextId =>
    setSearchParams(nextId != null ? { id: String(nextId) } : {});
  const clearId = () => setId(null);

  return { id, setId, clearId };
};

export default useRecordIdParam;
